module.exports = __webpack_public_path__ + "img/jianjie.7ce714a4.png";